import { Injectable } from '@angular/core';
import { NavigationExtras, Router, UrlSegmentGroup } from '@angular/router';

import { UrlQueryParams } from '@stylehaven/components';

@Injectable({ providedIn: 'root' })
export class OutletCloser {
    constructor(private readonly router: Router) {}

    closeOutlet(outletName: string, queryParams?: UrlQueryParams, error: boolean = false): Promise<boolean> {
        const currentUrlTree = this.router.parseUrl(this.router.routerState.snapshot.url);
        const newRootSegment = this.recursivelyClearOutlet(currentUrlTree.root, outletName);
        const extras: NavigationExtras | undefined = queryParams ? { queryParams, state: { error } } : undefined;
        currentUrlTree.root = newRootSegment;
        currentUrlTree.queryParams = {};

        return this.router.navigate([currentUrlTree.toString()], extras);
    }

    recursivelyClearOutlet(root: UrlSegmentGroup, outletName: string): UrlSegmentGroup {
        const newChildren: any = {};
        for (const [childOutlet, child] of Object.entries(root.children)) {
            if (childOutlet !== outletName) {
                const newChild = this.recursivelyClearOutlet(child, outletName);
                newChildren[childOutlet] = newChild;
            }
        }
        return new UrlSegmentGroup(root.segments, newChildren);
    }
}
